// Footer shipping country selector functionality
// Handles the dropdown toggle for the footer localization form

(function() {
  function initFooterLocalization() {
    const formElement = document.querySelector('.footer__shipping localization-form');
    const button = document.querySelector('.footer__shipping .localization-form__select');
    const panel = document.querySelector('.footer__shipping .disclosure__list-wrapper');
    
    if (button && panel && formElement) {
      // Toggle dropdown on button click
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const isHidden = panel.hasAttribute('hidden');
        if (isHidden) {
          panel.removeAttribute('hidden');
          button.setAttribute('aria-expanded', 'true');
        } else {
          panel.setAttribute('hidden', '');
          button.setAttribute('aria-expanded', 'false');
        }
      }, true);
      
      // Close dropdown when an option is clicked
      const countryLinks = panel.querySelectorAll('.disclosure__link');
      countryLinks.forEach(function(link) {
        link.addEventListener('click', function() {
          panel.setAttribute('hidden', '');
          button.setAttribute('aria-expanded', 'false');
        });
      });
      
      // Close dropdown when clicking outside
      document.addEventListener('click', function(e) {
        if (!formElement.contains(e.target)) {
          panel.setAttribute('hidden', '');
          button.setAttribute('aria-expanded', 'false');
        }
      });
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterLocalization);
  } else {
    initFooterLocalization();
  }
})();

